import React, { useState, useEffect } from 'react';

// --- Estilos CSS para el Modal ---
// Para una mejor organización, puedes mover estos estilos a tu archivo CSS principal (ej: CourseDetail003.css)
const PromoModalStyles = () => (
    <style>{`
.promo-overlay {
  position: fixed; top: 0; left: 0; width: 100%; height: 100%;
  background-color: rgba(0, 0, 0, 0.8); display: flex; justify-content: center;
  align-items: center; z-index: 1000; opacity: 0; animation: fadeIn 0.3s forwards;
  padding: 1rem; /* Añade un poco de espacio para que el modal no toque los bordes */
}
.promo-modal {
  background: #1f2937; color: white; padding: 2.5rem; border-radius: 15px;
  width: 90%; max-width: 550px; text-align: center;
  border: 1px solid #3b82f6; box-shadow: 0 10px 30px rgba(59, 130, 246, 0.2);
  transform: scale(0.9); animation: zoomIn 0.3s 0.1s forwards; position: relative;

  /* --- CAMBIOS CLAVE AQUÍ --- */
  max-height: 95vh; /* Se asegura de que el modal nunca sea más alto que el 95% de la pantalla */
  overflow-y: auto; /* Habilita el scroll vertical si el contenido se desborda */
}
.promo-modal .close-button {
  position: absolute; top: 15px; right: 15px; background: none; border: none;
  color: #9ca3af; font-size: 1.5rem; cursor: pointer; transition: color 0.2s;
}
.promo-modal .close-button:hover { color: white; }
.promo-modal .promo-icon {
  margin: 0 auto 1.5rem; width: 60px; height: 60px;
  background-color: rgba(74, 222, 128, 0.1); border-radius: 50%;
  display: flex; justify-content: center; align-items: center;
}
.promo-modal .promo-icon svg { width: 32px; height: 32px; color: #4ade80; }
.promo-modal .promo-title {
  font-size: 2.5rem; font-weight: 800; margin-bottom: 1rem;
  background-image: linear-gradient(to right, #3b82f6, #10b981);
  -webkit-background-clip: text; -webkit-text-fill-color: transparent;
  background-clip: text; text-fill-color: transparent;
}
.promo-modal .promo-text { color: #d1d5db; font-size: 1.1rem; margin-bottom: 1rem; /* Reducido un poco el margen */ }
.promo-modal .countdown-timer { margin-bottom: 2rem; }
.promo-modal .countdown-timer .timer-label {
  display: block; color: #9ca3af; margin-bottom: 0.5rem;
  text-transform: uppercase; font-size: 0.8rem; letter-spacing: 1px;
}
.promo-modal .countdown-timer .timer-time {
  font-size: 3rem; font-weight: 800; color: #4ade80; letter-spacing: 2px;
}
.promo-modal .promo-buttons { display: flex; flex-direction: column; gap: 1rem; }
.promo-modal .btn {
  border: none; padding: 1rem; font-size: 1rem; font-weight: 700;
  border-radius: 8px; cursor: pointer; transition: all 0.2s ease-in-out;
  text-transform: uppercase;
}
.promo-modal .btn-confirm {
  background-image: linear-gradient(to right, #3b82f6, #10b981); color: #ffffff;
}
.promo-modal .btn-confirm:hover {
  transform: scale(1.05); box-shadow: 0 5px 15px rgba(16, 185, 129, 0.4);
}
.promo-modal .btn-details { background-color: transparent; color: #9ca3af; }
.promo-modal .btn-details:hover { background-color: rgba(255, 255, 255, 0.1); color: white; }
@keyframes fadeIn { to { opacity: 1; } }
@keyframes zoomIn { to { transform: scale(1); } }
`}</style>
);


const PromoModal = ({ onClose, onConfirm, course, newPrice, oldPrice, currency }) => {
    const [timeLeft, setTimeLeft] = useState(60 * 60);

    useEffect(() => {
        if (timeLeft <= 0) return;
        const timer = setInterval(() => setTimeLeft((prev) => prev - 1), 1000);
        return () => clearInterval(timer);
    }, [timeLeft]);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };

    return (
        <>
            <PromoModalStyles />
            <div className="promo-overlay">
                <div className="promo-modal">
                    <button className="close-button" onClick={onClose}>&times;</button>
                    <div className="promo-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M13 18V20H11V18H3C2.44772 18 2 17.5523 2 17V11H0.5C0.223858 11 0 10.7761 0 10.5V8.5C0 8.22386 0.223858 8 0.5 8H2V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V8H23.5C23.7761 8 24 8.22386 24 8.5V10.5C24 10.7761 23.7761 11 23.5 11H22V17C22 17.5523 21.5523 18 21 18H13ZM20 5H4V11H11V5H13V11H20V5ZM11 16H4V13H11V16ZM13 16V13H20V16H13Z"></path></svg>
                    </div>
                    <h2 className="promo-title">¡Oferta Única y Exclusiva!</h2>
                    <p className="promo-text">
                        ¡Felicidades! HOY tienes acceso a una promoción especial en el valor de este curso que no volverá a repetirse
                    </p>
                    <p className="text-3xl text-slate-500 line-through" style={{ color: 'red', textDecoration: 'line-through', fontWeight: 'bold', fontSize: '20px' }}>
                        Antes: {oldPrice} {currency}
                    </p>
                    <p className="promo-text" style={{fontSize: '35px', fontWeight: 'bold'}}>
                        HOY: {newPrice} <span className="text-2xl font-medium text-slate-600">{currency}</span>
                    </p>
                 {/*   <div className="countdown-timer">
                        <span className="timer-label">Esta oferta termina en:</span>
                        <span className="timer-time">{formatTime(timeLeft)}</span>
                    </div>*/}
                    <div className="promo-buttons">
                        <button className="btn btn-confirm" onClick={onConfirm}>
                            ¡Deseo Inscribirme Ahora!
                        </button>
                        <button className="btn btn-details" onClick={onClose}>
                            Ver información detallada del curso
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PromoModal;

